<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="description" content="" />
        <meta name="author" content="" />
        <title>Dashboard - SB Admin</title>
        <link href="" rel="stylesheet" />
        <link href="https://cdn.datatables.net/1.10.20/css/dataTables.bootstrap4.min.css" rel="stylesheet" crossorigin="anonymous" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/js/all.min.js" crossorigin="anonymous"></script>
    </head>
    <body class="sb-nav-fixed">                
            <app-dashboard-header></app-dashboard-header>        
        <div id="layoutSidenav" >            
            <div id="layoutSidenav_content">
                <main class="bg-white">
                  <div class="container">  
                        <h1 class="mt-5 mb-5 text-center" >لوحـــة التحكم</h1>
                        <div class="row d-flex align-items-center">
                            <div class="col-xl-3 col-md-6 mb-4">
                                <div class="card text-white" style="background-color: rgb(53, 54, 114);">
                                    <div class="card-body">الصلاحيـات</div>
                                    <div class="card-footer d-flex align-items-center justify-content-between">
                                        <a class="small text-white stretched-link" routerLink="/getAllRoles">عرض التفاصيل</a>
                                        <div class="small text-white"><i class="fas fa-angle-left"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 mb-4">
                                <div class="card text-white" style="background-color: rgb(48, 104, 64);">
                                    <div class="card-body">المستخدمون</div>
                                    <div class="card-footer d-flex align-items-center justify-content-between">
                                        <a class="small text-white stretched-link" routerLink="/getAllUsers">عرض التفاصيل</a>
                                        <div class="small text-white"><i class="fas fa-angle-left"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 mb-4">
                                <div class="card text-white" style="background-color: rgb(95, 110, 45);">
                                    <div class="card-body">الاقسام</div>
                                    <div class="card-footer d-flex align-items-center justify-content-between">
                                        <a class="small text-white stretched-link" routerLink="/getAllCategoriesAdmin">عرض التفاضيل</a>
                                        <div class="small text-white"><i class="fas fa-angle-left"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 mb-4">
                                <div class="card text-white" style="background-color: rgb(129, 88, 41);">
                                    <div class="card-body">الدورات التدربية</div>
                                    <div class="card-footer d-flex align-items-center justify-content-between">
                                        <a class="small text-white stretched-link" routerLink="/getAllCoursesAdmin">عرض التفاصيل</a>
                                        <div class="small text-white"><i class="fas fa-angle-left"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="last-card col-xl-3 col-md-6">
                                <div class="card text-white" style="background-color: rgb(129, 39, 84);">
                                    <div class="card-body">المجموعات</div>
                                    <div class="card-footer d-flex align-items-center justify-content-between">
                                        <a class="small text-white stretched-link" routerLink="/getAllClassesAdmin">عرض التفاصيل</a>
                                        <div class="small text-white"><i class="fas fa-angle-left"></i></div>
                                    </div>
                                </div>
                            </div>
                            <div class="last-card col-xl-3 col-md-6">
                                <div class="card bg-dark text-white">
                                    <div class="card-body">الحلقات</div>
                                    <div class="card-footer d-flex align-items-center justify-content-between">
                                        <a class="small text-white stretched-link" routerLink="/getAllSessionsAdmin">عرض التفاصيل</a>
                                        <div class="small text-white"><i class="fas fa-angle-left"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>                     
                    </div>
                </main>                            
            </div>            
        </div>
        <app-dashboard-footer></app-dashboard-footer>
        <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js" crossorigin="anonymous"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/js/bootstrap.bundle.min.js" crossorigin="anonymous"></script>
        <script src="../../Admin_Dashboard/JS/scripts.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.8.0/Chart.min.js" crossorigin="anonymous"></script>
        <script src="../../Admin_Dashboard/Assets/demo/chart-area-demo.js"></script>
        <script src="../../Admin_Dashboard/Assets/demo/chart-bar-demo.js"></script>
        <script src="https://cdn.datatables.net/1.10.20/js/jquery.dataTables.min.js" crossorigin="anonymous"></script>
        <script src="https://cdn.datatables.net/1.10.20/js/dataTables.bootstrap4.min.js" crossorigin="anonymous"></script>
        <script src="../../Admin_Dashboard/Assets/demo/datatables-demo.js"></script>
    </body>
</html>
